import { Logs } from '../services/Logs.js';
import { UIFormElement } from './UIFormElement.js';

export class UIForm {

    constructor(options = {}) {
        if (!options.app) {
            throw new Error("UIForm requires an app option");
        }

        if (!options.container) {
            throw new Error("UIForm requires a container option");
        }

        if (!options.form) {
            throw new Error("UIForm requires a form option");
        }

        this.app = options.app;
        this.container = options.container;
        this.form = options.form;
        this.mode = options.mode;
        this.idModal = null;
        this.render();

        return this;
    }

    render() {
        new Logs("message", ["UI FORM", this.container, this.form, this.mode]);

        if (!this.getTarget(this.container)) {
            new Logs("error", ["Container not present in DOM, stop here."]);
            return false;
        }

        this.idModal = this.getModalId();
        this.appendForm();
        this.appendItems();
        this.appendButtons();
        this.bindSubmit();

        return this;
    }

    getTarget(container) {
        return typeof container === "string"
            ? document.querySelector(container)
            : container;
    }

    getModalId() {
        const target = this.getTarget(this.container);
        if (!target) return null;

        if (target.classList.contains("ui-modal")) {
            return target.id || this.container;
        }

        const modal = target.closest(".ui-modal");
        return modal ? modal.id : null;
    }

    appendForm() {
        const target = this.getTarget(this.container);
        if (!target) return false;

        const form = document.createElement("form");
        form.id = this.form.id;
        form.classList.add("ui-form");

        if (this.form.class) form.classList.add(...this.form.class.split(" ").filter(Boolean));
        if (this.form.autocomplete) form.autocomplete = this.form.autocomplete;

        target.append(form);

        return form;
    }

    appendItems() {
        this.getElements().forEach((element) => {
            this.renderElement(document.getElementById(this.form.id), element);
        });
    }

    appendButtons() {
        if (!this.form.buttons) return;

        const form = document.getElementById(this.form.id);
        if (!form) return false;

        const buttons = document.createElement("div");
        buttons.classList.add("ui-form-buttons");
        form.append(buttons);

        this.form.buttons.forEach((btn) => {
            let id = this.randomString();
            if (btn.id) id = btn.id;

            const button = document.createElement("button");
            button.type = btn.type || "button";
            button.classList.add("ui-buttons")
            button.id = id;

            if (btn.icon) {
                const icon = document.createElement("img");
                icon.src = `/images/${btn.icon}`;
                button.append(icon);
            }

            if (btn.label) {
                button.append(document.createTextNode(btn.label));
            }

            if (btn.class) button.classList.add(...btn.class.split(" ").filter(Boolean));
            if (btn.fct) button.addEventListener("click", () => btn.fct());

            buttons.append(button);
        });

        return buttons;
    }

    bindSubmit() {
        const form = document.getElementById(this.form.id);
        if (!form) return false;

        form.addEventListener("submit", (event) => {
            event.preventDefault();
            if (this.form.submit) this.form.submit();
        });
    }

    renderElement(container, data) {
        return new UIFormElement({
            app: this.app,
            container,
            data,
            mode: this.mode,
            elementId: data.element_id,
            idModal: this.idModal
        });
    }

    getElements() {
        if (!Array.isArray(this.form.content)) {
            return [];
        }

        return this.form.content.flatMap((item) => {
            if (item && item.type) {
                return [item];
            }

            if (item && Array.isArray(item.content)) {
                return item.content.map((subitem) => ({
                    ...subitem,
                    class: [item.class, subitem.class].filter(Boolean).join(" ") || undefined
                }));
            }

            return [];
        });
    }

    randomString() {
        if (this.app && typeof this.app.randomString === "function") {
            return this.app.randomString();
        }

        return `ui-form-${Math.random().toString(36).slice(2, 10)}`;
    }

}

globalThis.UIForm = UIForm;
